import { useAuth } from "../context/AuthContext";

// Rank: admin(3) > editor(2) > viewer(1)
export const ROLE_RANK = { viewer: 1, editor: 2, admin: 3 };

export function hasRole(user, minRole) {
  if (!user) return false;
  return (ROLE_RANK[user.role] || 0) >= (ROLE_RANK[minRole] || 0);
}

// Convenience hooks
export function useCan() {
  const { user } = useAuth();
  return {
    view: !!user,
    edit: hasRole(user, "editor"),
    admin: hasRole(user, "admin"),
    role: user?.role || null,
  };
}

export const ROLE_LABEL = {
  admin: "Admin",
  editor: "Editor",
  viewer: "Viewer",
};

export const ROLE_BADGE_CLASS = {
  admin: "bg-neutral-900 text-white border-neutral-900",
  editor: "bg-sky-50 text-sky-700 border-sky-200",
  viewer: "bg-neutral-100 text-neutral-700 border-neutral-200",
};
